(function() {
  const POPUP_ID = 'popup-milano-music-week';
  const COOKIE_NAME = 'mmw_popup_closed';
  const COOKIE_MAX_AGE = 60 * 60 * 24 * 180; // 6 mesi
  const QUERY_PARAM = 'mmw'; // ?mmw

  // --- GA4 / tracking helper ---
  function trackMmwEvent(action, extraData) {
    var params = {
      mmw_action: action
    };

    if (extraData && typeof extraData === 'object') {
      for (var key in extraData) {
        if (Object.prototype.hasOwnProperty.call(extraData, key)) {
          params[key] = extraData[key];
        }
      }
    }

    // GA4 via gtag.js (se presente)
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'mmw_popup', params);
    }

    // DataLayer per GTM (se presente)
    window.dataLayer = window.dataLayer || [];
    var dlEvent = Object.assign(
      {
        event: 'mmw_popup'
      },
      params
    );
    window.dataLayer.push(dlEvent);
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function setCookie(name, value, maxAgeSeconds) {
    document.cookie = `${name}=${value}; max-age=${maxAgeSeconds}; path=/`;
  }

  function hasQueryParam(param) {
    try {
      const params = new URLSearchParams(window.location.search);
      return params.has(param);
    } catch (e) {
      return false;
    }
  }

  function showPopup() {
    var popup = document.getElementById(POPUP_ID);
    if (!popup) return;
    popup.classList.remove('hidden');
    popup.classList.add('mmw-popup--visible');
  }

  function hidePopup(saveCookie, closedBy) {
    var popup = document.getElementById(POPUP_ID);
    if (!popup) return;
    popup.classList.remove('mmw-popup--visible');

    if (saveCookie) {
      setCookie(COOKIE_NAME, '1', COOKIE_MAX_AGE);
    }

    // traccia chiusura popup
    trackMmwEvent('popup_closed', {
      mmw_closed_by: closedBy || 'unknown'
    });
  }

  function distanceKm(lat1, lon1, lat2, lon2) {
    function toRad(x) { return x * Math.PI / 180; }
    var R = 6371;
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function fallbackCopy(text, btn) {
    try {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);

      if (btn) {
        btn.textContent = 'Copiato!';
        setTimeout(function() {
          btn.textContent = 'Copia codice';
        }, 2000);
      }

      // tracking copia codice (fallback)
      trackMmwEvent('discount_code_copied', {
        mmw_copy_method: 'fallback'
      });
    } catch (e) {
      // se fallisce pazienza
      trackMmwEvent('discount_code_copy_error', {
        mmw_copy_method: 'fallback',
        mmw_error_message: String(e && e.message ? e.message : e)
      });
    }
  }

  function initCopyButton(popup) {
    var btn = popup.querySelector('.mmw-popup__copy-btn');
    if (!btn) return;

    var targetSelector = btn.getAttribute('data-copy-target');
    if (!targetSelector) return;

    var targetEl = popup.querySelector(targetSelector);
    if (!targetEl) return;

    btn.addEventListener('click', function() {
      var text = targetEl.textContent.trim();
      if (!text) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function() {
          btn.textContent = 'Copiato!';
          setTimeout(function() {
            btn.textContent = 'Copia codice';
          }, 2000);

          // tracking copia codice (API moderna)
          trackMmwEvent('discount_code_copied', {
            mmw_copy_method: 'clipboard_api'
          });
        }).catch(function(err) {
          fallbackCopy(text, btn);
          trackMmwEvent('discount_code_copy_error', {
            mmw_copy_method: 'clipboard_api',
            mmw_error_message: String(err && err.message ? err.message : err)
          });
        });
      } else {
        fallbackCopy(text, btn);
      }
    });
  }

  function initPopup() {
    var popup = document.getElementById(POPUP_ID);
    if (!popup) return;

    var forceOpen = hasQueryParam(QUERY_PARAM); // ?mmw

    // --- CONTROLLO DATE (solo se NON forzo via query) ---
    if (!forceOpen) {
      var start = popup.dataset.startDate;
      var end = popup.dataset.endDate;

      if (start && end) {
        var todayStr = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
        if (todayStr < start || todayStr > end) {
          // fuori periodo: non faccio nulla
          trackMmwEvent('popup_not_shown_out_of_date', {
            mmw_today: todayStr,
            mmw_start_date: start,
            mmw_end_date: end
          });
          return;
        }
      }
    }
    // ----------------------------------------------------

    // se non sto forzando via query e ho già il cookie → non mostrare
    if (!forceOpen && getCookie(COOKIE_NAME)) {
      trackMmwEvent('popup_not_shown_cookie', {
        mmw_cookie_name: COOKIE_NAME
      });
      return;
    }

    var closeBtn = popup.querySelector('.mmw-popup__close');
    var overlay = popup.querySelector('.mmw-popup__overlay');

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        hidePopup(true, 'button');
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function() {
        hidePopup(true, 'overlay');
      });
    }

    // bottone "Copia codice"
    initCopyButton(popup);

    // 1) Caso override: ?mmw → SEMPRE apre, ignorando date e cookie
    if (forceOpen) {
      showPopup();
      trackMmwEvent('popup_open_forced_query', {
        mmw_force_param: QUERY_PARAM
      });
      return;
    }

    // 2) Caso normale: geo + raggio
    if (!navigator.geolocation) {
      trackMmwEvent('geo_unavailable', {});
      return;
    }

    var targetLat = parseFloat(popup.dataset.targetLat);
    var targetLng = parseFloat(popup.dataset.targetLng);
    var radiusKm = parseFloat(popup.dataset.radiusKm) || 50;

    navigator.geolocation.getCurrentPosition(
      function(position) {
        var userLat = position.coords.latitude;
        var userLng = position.coords.longitude;
        var d = distanceKm(targetLat, targetLng, userLat, userLng);

        // chi ha ACCETTATO la geo (ovunque sia)
        trackMmwEvent('geo_success', {
          mmw_distance_km: d,
          mmw_radius_km: radiusKm
        });

        if (d <= radiusKm) {
          showPopup();
          // apertura popup per geo nel raggio
          trackMmwEvent('popup_open_geo_in_radius', {
            mmw_distance_km: d,
            mmw_radius_km: radiusKm
          });
        } else {
          // ha accettato la geo ma è fuori raggio
          trackMmwEvent('geo_out_of_radius', {
            mmw_distance_km: d,
            mmw_radius_km: radiusKm
          });
        }
      },
      function(error) {
        console.log('[MMW POPUP] Errore geolocation:', error.code, error.message);

        trackMmwEvent('geo_error', {
          mmw_geo_error_code: error.code,
          mmw_geo_error_message: String(error && error.message ? error.message : error)
        });
      },
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
    );
  }

  document.addEventListener('DOMContentLoaded', initPopup);
})();
